// The catalogs accept at most 50 characters, the single company form uses the same limit.
export const PHONE_DESCRIPTION_MAX_LENGTH = 50;
